import { Scene } from "phaser";
import { GButton } from "../gameobjects/GButton";
import { transitionScenes } from '../Transition';
import { getCurrentDraw, setLetterSpacing,applyLetterSpacing  } from '../utils';
import { TimerObject } from "../gameobjects/TimerObject";


import { getPastDraws, datetimeToUnixTimestamp  } from '../utils';


export class MenuScene extends Scene {
    constructor() {
        super("MenuScene");
        this.scene
    }

    init() {
        this.cameras.main.fadeIn(200, 0, 0, 0);
        //this.game_over_timeout = 1728897012
        //this.registry.set('drawdate', this.game_over_timeout);
    }

    async requestDevicePermission() {
        if (typeof DeviceMotionEvent.requestPermission === 'function') {
          try {
            const permission = await DeviceMotionEvent.requestPermission();
            if (permission === 'granted') {
              this.setupDeviceOrientation();
            } else {
              console.log("Device motion permission denied");
            }
          } catch (error) {
            console.error("Device motion request failed:", error);
          }
        } else {
          // If no permission needed, proceed
          this.setupDeviceOrientation();
        }
      }

    setupDeviceOrientation() {
        window.addEventListener('deviceorientation', (event) => {
          // Use device orientation data to adjust plane rotation
          // Here, we map alpha, beta, gamma to small rotations on the plane GameObject
          const { alpha, beta, gamma } = event;
      
          // Update rotation values in radians for slight rotation
          // Scaling down the values for a subtle effect
          const xRotation = Phaser.Math.DegToRad(beta * 0.01); // X-axis tilt
          const yRotation = Phaser.Math.DegToRad(gamma * 0.01); // Y-axis tilt
          const zRotation = Phaser.Math.DegToRad(alpha * 0.01); // Z-axis rotation
      
          if (this.scene && this.scene.plane) {
            this.scene.plane.rotation = zRotation;
            this.scene.plane.setAngle(Phaser.Math.RadToDeg(xRotation)); // Adjust x-axis rotation slightly
            this.scene.plane.setAngle(Phaser.Math.RadToDeg(yRotation)); // Adjust y-axis rotation slightly
          }
        });
      }

    async create() {

     

        const add = this.add;
        const myScene = this.scene
        const sWidth = this.scale.width;
        const sHight = this.scale.height;
        const JackpotmaxWidth = 300*2


        const responseCurrent = await getCurrentDraw(this.registry.get('gamecode')); 

        if(responseCurrent.status !== 200){
            // this.scene.start("ErrorScene", {message: "No Player Information"});
            // return;
        }

       var menuConfig = {
        SecondBG: {
            x: sWidth/2,
            y: sHight/2,
            image: 'second-bg',
        },
        PrizePool: {
            x: sWidth/2,
            y: sHight/2 - 52,
            fontSize: 46,
        },
        stayTuned: {
            x: sWidth/2,
            y: sHight/2,
            
        },
        PrizeAmount: {
            x: sWidth/2,
            y: sHight/2+64,
            fontSize: 220,
        },
        lotto: {
            x: sWidth/2,
            y: sHight/2 - 168,
            fontSize: 60,
        }
       }

       if(!window.isMobile){
        menuConfig = {
            SecondBG: {
                x: sWidth/2,
                y: sHight/2,
                image: 'desktop-bg-round',
            },
            PrizePool: {
                x: sWidth/2,
                y: sHight/2 - 110,
                fontSize: 64,
            }, 
            PrizeAmount: {
                x: sWidth/2,
                y: sHight/2 - 40,
                fontSize: 220,
            },
            stayTuned: {
                x: sWidth/2,
                y: sHight/2,
            },
            lotto: {
                x: sWidth/2,
                y: sHight/2 - 170,
                fontSize: 42,
            }
        }
       }

        this.registry.set('my-tickets',responseCurrent.data.tickets);
        this.registry.set('currentDraw', responseCurrent.data);
        this.registry.set('lottery', responseCurrent.data.lottery);

       

        this.currentDrawInfo = this.registry.get('currentDraw') || {};
        this.currentJackPot =  this.formatNumberWithCommas(this.currentDrawInfo?.jackpot_amount || 0)
        //myScene.setActive(true)
        //this.currentDrawInfo = {}

       
        if(this.currentJackPot == 0) {
            this.SecondBG = this.add.image(this.scale.width/2, this.scale.height/2-62, 'no-draw').setOrigin(0.5);
            //this.SecondBG.setScale(0.8)


         

            this.stayTuned = add.text(sWidth/2, sHight/2, 'STAY TUNED',  { fontSize: 160, fontFamily: 'Oswald', color: '#eee', fontWeight:700 }).setOrigin(0.5).setFontStyle("700");
            this.stayTuned.setStroke('#000000',1);

            const fx1 = this.stayTuned.postFX.addGlow(0x00FFF0, 1, 0, false, 0.1, 50);

            if (this.stayTuned.width > JackpotmaxWidth) {
                // Calculate the scaling factor based on the maxWidth and current width
                const scaleFactor = JackpotmaxWidth / this.stayTuned.width;
                // Apply the scaling factor
                this.stayTuned.setScale(scaleFactor);
            }
            
            this.stayTunedSecond = add.text(sWidth/2, sHight/2 + 120, `FOR THE NEXT EXCITING DRAW!`,{ fontFamily: 'Oswald', fontSize: 48, color: '#ffffff' }).setOrigin(0.5).setFontStyle("400");
            //this.prizeAmountText.setShadow(0,0, '#00FFF0',10 );
            this.stayTunedSecond.setStroke('#000000',3);

            


        }else {

            // if (!window.isMobile) {
            //     this.SecondBG = this.add.image(this.scale.width/2, this.scale.height/2, 'desktop-bg-round').setOrigin(0.5);
            //     //this.SecondBG.setSize(343*2, 520*2)
            // } else {
            //     this.SecondBG = this.add.image(this.scale.width/2, this.scale.height/2-62, 'second-bg').setOrigin(0.5);
            //     //this.SecondBG.setSize(343*2, 520*2)
            // }

            this.SecondBG = this.add.image(menuConfig.SecondBG.x, menuConfig.SecondBG.y, menuConfig.SecondBG.image).setOrigin(0.5);

            this.prizePool = this.add.bitmapText(menuConfig.PrizePool.x, menuConfig.PrizePool.y,  'Oswald-Regular','LOTTERY PRIZE POOL', menuConfig.PrizePool.fontSize).setOrigin(0.5,0);
            this.prizePool.setScale(window.isMobile?1:0.5);
// -48
            this.prizeAmountText = this.add.bitmapText(menuConfig.PrizeAmount.x, menuConfig.PrizeAmount.y,  'oswald2', `$${this.currentJackPot}`, menuConfig.PrizeAmount.fontSize);

            

            //this.prizeAmountText = add.text(menuConfig.PrizeAmount.x, menuConfig.PrizeAmount.y,`$${this.currentJackPot}`,{ fontFamily: 'Oswald-mid', fontSize:  menuConfig.PrizeAmount.fontSize, color: '#ffffff' }).setOrigin(0.5).setFontStyle("700");
            this.prizeAmountText.setScale(window.isMobile?1:0.5);          
            this.prizeAmountText.setOrigin(0,0.5);
            // TODO: Add glow effect
            //this.prizeAmountText.postFX.addGlow(0xFFD700 , 1, 0, false, 0.5, 16);


            const prizeAmountWidth = this.prizeAmountText.width;

            console.log("prizeAmountWidth", prizeAmountWidth, JackpotmaxWidth)
            if (this.prizeAmountText.width > JackpotmaxWidth) {
                // Calculate the scaling factor based on the maxWidth and current width
                let scaleFactor = JackpotmaxWidth / this.prizeAmountText.width;

                if (!window.isMobile) {
                    scaleFactor = scaleFactor * 0.5;
                }
        
                // Apply the scaling factor
                this.prizeAmountText.setScale(scaleFactor);
                
            }

            const currentMax = prizeAmountWidth > JackpotmaxWidth?JackpotmaxWidth:prizeAmountWidth
            this.prizeAmountText.setPosition(this.scale.width/2 - currentMax/2, this.prizeAmountText.y)

            //this.ShineFx = this.prizeAmountText.postFX.addShine(1, .3, 3);
            //const fx1 = this.prizeAmountText.postFX.addGlow(0x00FFF0, 1, 0, false, 0.1, 50);
        

            if (!this.registry.has("runNumbers")) {
         
                const targetNumber = this.currentDrawInfo?.jackpot_amount || 0

                // Dummy object to hold the counting value
                   const counter = { value: targetNumber/2 };
   
                   const step = 1;                     // The increment step
                   const frameSkip = 3;                  // Update every 2 frames to slow down the display
                   let frameCounter = 0;                 // Counter for frame skipping
   
                   // Create a tween to animate the counter value
                   this.tweens.add({
                       targets: counter,
                       value: targetNumber,           // Target value for the counter
                       duration: 2500,                // Duration in milliseconds
                       ease: 'Cubic.easeOut',         // Easing function
                       onUpdate: () => {
                           // Update the text object with the current counter value (rounded)
                           // Increment the counter by the specified step value
                           //counter.value += step;
   
                           // Only update the text display every `frameSkip` frames
                           frameCounter++;
                           //if (frameCounter >= frameSkip) {
                               this.prizeAmountText.setText("$" + this.formatNumberWithCommas(Math.floor(counter.value)));
   
   
                               if (this.prizeAmountText.width > JackpotmaxWidth) {
                                   // Calculate the scaling factor based on the maxWidth and current width
                                   const scaleFactor = JackpotmaxWidth / this.prizeAmountText.width;
                           
                                   // Apply the scaling factor
                                   //this.prizeAmountText.setScale(scaleFactor);
                                   this.prizeAmountText.setSize(JackpotmaxWidth, JackpotmaxWidth*scaleFactor)
                                   //console.log(Math.floor(this.prizeAmountText.x), this.prizeAmountText.y, this.prizeAmountText.width)
                                   
                                   //this.prizeAmountText.setPosition(this.scale.width , this.scale.height )
   
                               }
                               const currentMax = prizeAmountWidth > JackpotmaxWidth?JackpotmaxWidth:prizeAmountWidth
                               this.prizeAmountText.setPosition(this.scale.width/2 - currentMax/2, this.prizeAmountText.y)
                           //this.prizeAmountText.setPosition(this.prizeAmountText.x - this.prizeAmountText.width/2, sHight/2 + 120 )
   
                             //  frameCounter = 0;       // Reset frame counter
                           //}
                       },
                       onComplete: () => {

                        
                            this.prizeAmountText.setText("$" + this.formatNumberWithCommas(targetNumber));
                            const currentScaleX = this.prizeAmountText.scaleX;
                            const currentScaleY = this.prizeAmountText.scaleY;
                           
                       }
                   });

        
                // Save the key with a value so this action is not repeated
                this.registry.set("runNumbers", true);
            }


        }
        
        this.lotto = this.add.bitmapText(menuConfig.lotto.x, menuConfig.lotto.y,  'oswald2',this.currentDrawInfo.lottery.name.toUpperCase(), menuConfig.lotto.fontSize).setOrigin(0.5,0);


        
        const draw_date_realTime = datetimeToUnixTimestamp(this.currentDrawInfo?.draw_date)
        
        var draw_date_unixtime  = draw_date_realTime;
        if(this.currentDrawInfo.status == "closed"){
            const twoMinutesInSeconds = 2 * 60; // 2 minutes in seconds
            draw_date_unixtime += twoMinutesInSeconds
        }
        
       
        this.registry.set('drawdate', draw_date_unixtime);
        
        // myScene.launch("TimerScene", { remaining_time: draw_date_unixtime, status: this.currentDrawInfo.status});   
        // const timerScene = myScene.get("TimerScene");
        // timerScene.events.once('start', () => {
        //     //this.scene.setVisible(false);
        // });


        // Create a render texture with the same size as the game
        this.renderTexture = this.add.renderTexture(0, 0, this.scale.width, this.scale.height);
        this.renderTexture.setVisible(false); // Hide the Render Texture; it's used for sampling

        // Draw the background image with PreFX onto the render texture
        this.renderTexture.clear();
        this.renderTexture.draw([this.SecondBG], 0, 0);//bg.x - bg.width / 2, bg.y

        
        if (!this.textures.exists('timerBackground')) {
            this.renderTexture.saveTexture('timerBackground');
        }


        let timeConfig = {
            x: this.scale.width/2-290/2,
            y: this.scale.height - 240,
            width: 290,
            height: 120,
            radius: 10,
            timerY: this.scale.height - 240,
            timerScale: 0.5,
            bgtexture:'desktop-bg-round',
            borderLine: 2
        }

        if(window.isMobile){

        // Create a render texture for the combined background
        this.combinedBackgroundRT = this.add.renderTexture(0, 0, this.scale.width, this.scale.height);
        this.combinedBackgroundRT.setVisible(false);

        // Draw the blurred background first
        this.combinedBackgroundRT.clear();
        this.combinedBackgroundRT.draw([this.scene.get('MainScene').children], 0, 0, 0.5);
        
        // Draw the second background on top
        this.combinedBackgroundRT.draw([this.SecondBG], this.SecondBG.x, this.SecondBG.y);

        //this.combinedBackgroundRT.postFX.addGradient(0x7F00FF, 0x070012, 0.7, 0.5, 1, 0.2, 0.5, 0);

        const gradient = this.add.graphics();
        const topColor = 0x111122;
        const bottomColor = 0x4444aa;

        //gradient.fillStyle(0xff00ff, 0.1);
        gradient.fillGradientStyle(0x070012, 0x070012, 0x070012, 0x7F00FF, 0.3);
        gradient.fillRect(0, this.scale.height/2, this.scale.width, this.scale.height);
        gradient.setVisible(false);

        // Draw it into the RT
        this.combinedBackgroundRT.draw(gradient, 0, 0);

        // Save the combined texture if it doesn't exist
        if (!this.textures.exists('combinedBackground')) {
            this.combinedBackgroundRT.saveTexture('combinedBackground', this.combinedBackgroundRT.texture);
        }


        timeConfig.x = this.scale.width/2-290;
           timeConfig.timerY = this.scale.height/2 + this.scale.height/4 -30;
           timeConfig.timerScale = 1;
           timeConfig.width = 290*2;
           timeConfig.height = 120*2;
           timeConfig.radius = 10;
           timeConfig.bgtexture = 'combinedBackground'
           timeConfig.borderLine = 3;
        }        

        this.timerBG = this.add.graphics();
        this.timerBG.fillStyle(0xffff00, 1);
        this.timerBG.fillRoundedRect(timeConfig.x,timeConfig.timerY, timeConfig.width, timeConfig.height, timeConfig.radius);
        this.timerBG.setVisible(false);


      

        // Create a sprite from the combined render texture
        // this.combinedBackground = this.add.sprite(this.scale.width/2,this.scale.height/2, 'combinedBackground');
        // this.combinedBackground.setOrigin(0.5, 0.5);
        // this.combinedBackground.setDisplaySize(this.scale.width, this.scale.height);


        const checker = this.add.sprite(this.scale.width/2,this.scale.height/2, timeConfig.bgtexture);
        //checker.mask = new Phaser.Display.Masks.BitmapMask(this, this.timerBG);
        //checker.setScale(1).setAlpha(1).setDisplayOrigin(this.scale.width/2,this.scale.height/2);
        
        //checker.setTint(0x9C9C9C, 0x070012, 0x070012, 0x7F00FF);
        //checker.setAlpha(0.8);

        checker.preFX.addBlur(2,1,1,3);

        if (!this.textures.exists('checkerTexture')) {
            const checkerTexture = this.add.renderTexture(0, 0, this.scale.width, this.scale.height);
            checkerTexture.draw(checker, this.scale.width/2,this.scale.height/2);
            checkerTexture.saveTexture('checkerTexture', checkerTexture.texture);
            checkerTexture.setVisible(false);
        }

        // const checkerTexture = this.add.renderTexture(0, 0, this.scale.width, this.scale.height);
        // checkerTexture.draw(checker, this.scale.width/2,this.scale.height/2);
        // checkerTexture.saveTexture('checkerTexture', checkerTexture.texture);
        // checkerTexture.setVisible(false);
        
        const checkerSprite = this.add.sprite(this.scale.width/2, this.scale.height/2, 'checkerTexture');
        checkerSprite.setOrigin(0.5, 0.5);
        checkerSprite.setDisplaySize(this.scale.width, this.scale.height);
        checkerSprite.mask = new Phaser.Display.Masks.BitmapMask(this, this.timerBG);
        
        checker.preFX.clear()
        checker.destroy();

        //var gradient = checker.preFX.addGradient(0x7F00FF, 0x070012, 0.7, 0.5, 1, 0.2, 0.5, 0);

        // TODO: Remove prefx and bake it into a texture


        this.timerObject = new TimerObject(this, this.scale.width/2, timeConfig.timerY);   
        //this.timerObject.postFX.addGlow(0x00aaa0, 1, 0, true, 0.4, 18);
        //const fxShadow = this.timerObject.preFX.addShadow(0, 0, 0.006, 2, 0x00aaa0, 10);
        this.timerObject.setScale(timeConfig.timerScale);
        
        const boundsTimer = this.timerObject.getBounds()
        this.timerObject.setPosition(this.scale.width/2 - boundsTimer.width/2, timeConfig.timerY)
        //this.timerObject.setDisplaySize( 290, 120);
        


        this.timerBorderGraphics = this.add.graphics();
        this.timerBorderGraphics.lineStyle(timeConfig.borderLine, 0xffffff, 0.5);
        this.timerBorderGraphics.strokeRoundedRect(timeConfig.x,timeConfig.timerY, timeConfig.width, timeConfig.height, 10);
        
        // const renderTexture = this.add.renderTexture(0, 0, this.scale.width, this.scale.height);
        
        // // Render the TimerScene into the render texture
        // renderTexture.draw(timerScene, 0, 0);
        
        // // Scale the render texture to 0.5
        // renderTexture.setScale(0.5);
        
        // // Hide the TimerScene
        // //timerScene.setVisible(false);
        
        // // Show the render texture instead
        // renderTexture.setVisible(true);

        
      

        
        //console.log(" this.SecondBG.y - this.SecondBG.hight/2",  this.SecondBG.y , this.SecondBG)
        const latestResutls = new GButton( this, this.scale.width/2,  this.SecondBG.y - this.SecondBG.height/2 +100, {
            texturePack: "pack", 
            idleTexture: 'Button - Secondary - Default.png',
            clickedTexture: 'Button - Secondary - Clicked.png',
            disabledTexture: 'Button - Secondary - Disabled.png',
            icon: {
                image: 'trophy.png',
                scale: 0.75,
                align: 'left'
            },
            text: {
                value:'LATEST RESULTS',
                style:  { fontFamily: 'Montserrat', fontSize: 22, color: '#ffffff' }
            },
            onClick: () => {
                this.scene.stop("MenuScene")
                if(window.isMobile){
                    this.scene.launch("ResultsScene", {draw_date_id: this.registry.get('latest_draw')})
                }else{
                    this.scene.launch("ResultsSceneDesktop", {draw_date_id: this.registry.get('latest_draw')})
                }
             }
        });

        latestResutls.setVisible(false);

        if(!window.isMobile){
            latestResutls.setScale(0.5);
            latestResutls.setPosition(220, 150)
        }
        


    // Create button 

    const ButtonMyTickets = new GButton( this, this.scale.width/2 - 180, this.scale.height -106, {
        texturePack: "pack", 
        idleTexture: 'Button - Secondary - Default.png',
        clickedTexture: 'Button - Secondary - Clicked.png',
        disabledTexture: 'Button - Secondary - Disabled.png',
        text: {
            value:'MY TICKETS',
            style:  { fontFamily: 'Oswald', fontSize: 32, color: '#ffffff' }
        },
        onClick: () => {
            //console.log('Button ButtonMyTickets!');
            this.scene.stop("MenuScene")
            if(window.isMobile){
                this.scene.launch("MyTicketsScene")
            }else{
                this.scene.launch("MyTicketsSceneDesktop")
            }
         }
    })

    if(!window.isMobile){
        ButtonMyTickets.setScale(0.5);
        ButtonMyTickets.setPosition(this.scale.width/2 - 90, this.scale.height - 50)
    }

    if(this.currentJackPot == 0 ){
        ButtonMyTickets.setDisabled()
    }
    

    this.ButtonBuyTickets = new GButton(this, this.scale.width/2 + 180, this.scale.height - 106, {
        texturePack: "pack", 
        idleTexture: 'Button - Primary - Default.png',
        clickedTexture: 'Button - Primary - Clicked.png',
        disabledTexture: 'Button - Primary - Disabled.png',
        text: {
            value:'BUY TICKET',
            style:  { fontFamily: 'Oswald', fontSize: 32, color: '#ffffff' }
        },
        onClick: () => {
            //console.log('Button ButtonBuyTickets!');
            this.scene.stop("MenuScene")
            if(window.isMobile){
                this.scene.launch("BuyTicketScene")
            }else{
                this.scene.launch("BuyTicketSceneDesktop")
            }
         }
    });

    if(!window.isMobile){
        this.ButtonBuyTickets.setScale(0.5);
        this.ButtonBuyTickets.setPosition(this.scale.width/2 + 90, this.scale.height - 50)
    }

    if(this.currentJackPot == 0 || this.currentDrawInfo.status != "open"){
        this.ButtonBuyTickets.setDisabled()
    }
    



        
        const response = await getPastDraws(this.registry.get('gamecode')); 

        if(response.status !== 200){
            this.scene.start("ErrorScene", {message: "No Player Information"});
            return;
        }

        if(response.data.total >0 ){
            latestResutls.setVisible(true);
            this.registry.set('latest_draw', response.data.draw_dates[0].id);
            this.registry.set('past_draws', response.data.draw_dates);
        }



        this.events.on('shutdown', () => {
            //console.log('MenuScene is stopped. Stopping TimerScene...');
            this.scene.stop('TimerScene');  // Stop SceneB when SceneA is stopped
        });



        // Listen for the custom event from Scene A
        this.events.on('DrawEvent', (data) => {
            console.log(data.message); // Outputs: "Hello from Scene A"
            // You can add additional logic here based on the event
            this.scene.start();
        });

        // Listen for the custom event from Scene A
        this.events.on('CloseEvent', (data) => {
            console.log(data.message); // Outputs: "Hello from Scene A"
            this.ButtonBuyTickets.setDisabled()
        });


        this.events.once('shutdown', this.onShutdown, this);

        //  // Check if the 'shutdown' event already has a listener
        //  if (this.events.listenerCount('pause') === 0) {
        //     // In your scene, add an event listener for 'pause' and 'resume'
        //         this.events.on('pause', () => {
        //             this.cameras.main.removePostPipeline('YourPostFXPipeline');
        //             console.log('PostFX removed on pause');
        //         });


        // }

        this.cameras.main.on('prerender', () => {
            if (this.scene.isPaused()) {
                this.cameras.main.postFXActive = false; // Temporarily disable PostFX
                //console.log("this.cameras.main.postFXActive = false;")
            } else {
                this.cameras.main.postFXActive = true; // Re-enable PostFX when the scene is active
                //console.log("this.cameras.main.postFXActive = true;")
            }
        });


        this.events.on('resume', this.onResume, this);
        this.events.on('pause', this.onPause, this);



    }

    applyLetterSpacing(data){
      
       data.x = data.x + 10 * data.index
  

        return data;
    }

    onResume(that) {
        //console.log("resume")
        if(this.prizeAmountText !== undefined){
            //this.ShineFx = this.prizeAmountText.postFX.addShine(1, .3, 3);
        }
        
     
    }

    
    onPause(that) {
        //console.log("pause")
        if(this.prizeAmountText !== undefined){
            //this.prizeAmountText.postFX.remove(this.ShineFx); 
        }
        
     
    }


    update() {

       
    }

    takeSnapshot() {
        // Take a snapshot of the current game renderer
        this.game.renderer.snapshot((image) => {
            // Create a new RenderTexture
            const renderTexture = this.add.renderTexture(400, 300, 800, 600);
            
            // Draw the captured snapshot onto the RenderTexture
            renderTexture.draw(image, 0, 0);
        });
    }

    formatNumberWithCommas(numberString) {
        // Convert the string to a number, then format it with commas
        return parseInt(numberString, 10).toLocaleString();
    }

    datetimeToUnixTimestamp(datetimeString) {
        // Create a Date object from the datetime string
        const date = new Date(datetimeString);
    
        // Get the Unix timestamp in seconds by dividing by 1000
        return Math.floor(date.getTime() / 1000);
    }

    // Ensure you remove the event listener if the scene is stopped or shutdown
    onShutdown() {
        //console.log("Shutdown Menu Scene")
        const sceneB = this.scene.get('TimerScene');
       // sceneB.events.off('myEvent', this.handleEventFromSceneB, this);
        this.events.off('DrawEvent');
        this.events.off('CloseEvent');
    }
    
    // Example usage
    

}